import { useEffect } from "react";
import "./styles.css";
import { useOnboarding } from "../../../hooks/useOnboarding";
import { ReactComponent as LogoPastejo } from "../../../assets/svg/logo/logoPastejo.svg";
import { StepByStep } from "../../../components/Onboarding/Template/StepByStep/Index";
import { CreateProfiles } from "../Register/CreateProfiles/Index";
import { CreateAreas } from "../Register/CreateAreas/Index";
import { CreateAssortment } from "../Register/CreateAssortment/Index";
import { CreateFarms } from "../Register/CreateFarms/Index";
import { CreateMicroAreas } from "../Register/CreateMicroAreas/Index";
import { OnboardingShapeFile } from "../Register/ShapeFile";
import { Summary } from "../Register/Summary/Index";

export function Onboarding() {
  const { screenComponent, screenNumber, subScreenNumber, userProgress, modalError, setModalError } = useOnboarding();

  function handleTitle() {
    const section = userProgress.find((sec) => sec.section === screenNumber);
    if (section && section.screens) document.title = `Pastejo | ${section?.screens[subScreenNumber]?.name}`;
    else document.title = "Pastejo";
  }

  useEffect(() => {
    handleTitle();
  }, [userProgress]);

  return (
    <section className="onboarding__container">
      <div className="onboarding__logo">
        <LogoPastejo />
      </div>
      <div className="onboarding__nav">
        <div className="onboarding__nav--menu">
          <div className="onboarding__nav--items">
            <StepByStep
              title="Onboarding"
              stepNumber={1}
              subSteps={[
                { name: "ShapeFile", element: <OnboardingShapeFile /> },
                { name: "Perfil", element: <CreateProfiles onBoarding={true} /> },
                { name: "Agropecuária", element: <CreateAssortment onBoarding={true} /> },
                { name: "Fazenda", element: <CreateFarms onBoarding={true} /> },
                { name: "Retiro", element: <CreateAreas /> },
                { name: "Pasto", element: <CreateMicroAreas onBoarding={true} /> },
                { name: "Resumo", element: <Summary /> },
              ]}
              lastStepAsSummary
            />
          </div>
        </div>
      </div>
      <section className="onboarding__content">{screenComponent}</section>
    </section>
  );
}
